import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserEmailTemplatesService } from '../../../../services/crud/user-email-templates.service';
import { ConfirmDialogComponent } from '../../../../shared/confirm-dialog/confirm-dialog.component';
import { EmailTemplate } from '../../../../dto/templates/email-template';

@Component({
  selector: 'app-user-email-templates',
  templateUrl: './user-email-templates.component.html',
  styleUrls: ['./user-email-templates.component.css']
})
export class UserEmailTemplatesComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private templatesService: UserEmailTemplatesService) { }


    dataSource: EmailTemplate[];

  ngOnInit() {
    this.templatesService.getMany().subscribe(result => {
      this.dataSource = result.data;
    });
  }

  deleteTemplate(id: number) {
    this.dialog.open(ConfirmDialogComponent).afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.templatesService.delete(id).subscribe(data => {
          const idx = this.dataSource.findIndex(x => x.id == id);
          this.dataSource.splice(idx, 1);
        });
      }
    });
  }
}
